import gql from 'graphql-tag';
import { kmsClient } from 'api';
import { useLazyQuery } from '@apollo/react-hooks';
import { KeyweeFeedArticlesQuery, KeyweeFeedArticlesQueryVariables } from './__generated__/KeyweeFeedArticlesQuery';

export const KEYWEE_FEED_ARTICLES_QUERY = gql`
  query KeyweeFeedArticlesQuery($filter: KeyweeFeedArticlesFilterInput!, $campaignId: ID!) {
    keyweeFeedArticles(filter: $filter, campaignId: $campaignId) {
      totalCount
      error
      articles {
        title
        url
        publishedAt
        articleInsight {
          comments
          likes
          linkClicks
          shares
          views
        }
        facebookPosts {
          externalId
          facebookPostInsight {
            comments
            likes
            linkClicks
            shares
            views
          }
        }
      }
    }
  }
`;

export const useKeyweeFeedArticlesLazyQuery = () => {
  return useLazyQuery<KeyweeFeedArticlesQuery, KeyweeFeedArticlesQueryVariables>(KEYWEE_FEED_ARTICLES_QUERY, {
    client: kmsClient,
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true
  });
};
